import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import styles from './dashboardListView.module.scss';
import { newCopiaStore } from '../../../../modules/copia/newCopia.store';
import CardSkeleton from '../../../../ui/skeleton';
import { getCardRenderer } from '../../../cards/cardsRenderer';
import filterStore from '../../../CustomFilter/filter.store';
// import Ortakbanner from '../../ortakBanner';
import OrtakRealtyModal from '../../../ortakRealtyModal';
import { Fragment } from 'react';

const DashboardListView = observer(
  ({ listModeActive }: { listModeActive: boolean }) => {
    const { showMap, cards, showOrtakPopup, setShowOrtakPopup } = newCopiaStore;
    const { isLoading } = filterStore;
    const { category } = useParams();
    const CardComponent = getCardRenderer(category as string);

    return (
      <>
        {/* {category === 'constructors' && (
          <Ortakbanner setShowOrtakPopup={setShowOrtakPopup} />
        )} */}
        <div
          className={cn(styles.dashboardCardsContainer, {
            [styles.galleryMode]: !listModeActive,
            [styles.cardsHide]: showMap,
          })}
        >
          {!!cards.length &&
            cards.map((room: any, index: number) => (
              <Fragment key={`${room.id}_${index}`}>
                <CardComponent
                  room={room}
                  index={index}
                  isOrtak={room.issuedBy === 1 && room.websiteLink}
                />
              </Fragment>
            ))}
          {isLoading && (
            <CardSkeleton
              count={6}
              className={
                !listModeActive ? styles.skeletonList : styles.skeletonGallery
              }
            />
          )}
        </div>
        {showOrtakPopup && (
          <OrtakRealtyModal
            cards={cards}
            setShowOrtakPopup={setShowOrtakPopup}
          />
        )}
      </>
    );
  },
);

export default DashboardListView;
